<template>
  <div>
    <v-dialog
      v-model="deposit_dialog"
      max-width="500px"
      transition="dialog-transition"
      scrollable
      persistent
    > 
      <v-card v-if="deposit_dialog && one_deposit.id" style="overflow: hidden !important;">
        <v-card-title class="blue-grey white--text py-2">
          <v-btn icon class="mr-2">
            <v-icon class="white--text" @click="$emit('closeDepositDialog')">mdi-close</v-icon>
          </v-btn>
          Depósito
          <v-spacer></v-spacer>
          <DialogOrdersPayedBySource dark :payment_id="one_deposit.payment_id"></DialogOrdersPayedBySource>
          <DownloadPaymentResume dark :payment_id="one_deposit.payment_id"></DownloadPaymentResume>
        </v-card-title>
        <v-card-text>
          <card-loading-transparent loadingText="Salvando" v-if="loading_saving"></card-loading-transparent>
        </v-card-text>
        <v-card-text v-if="!loading_saving">
          <v-form class="mt-2">
          
            <v-row justify="center">
              <v-col>
                <v-text-field label="Cliente" :disabled="edit.infos" readonly :value="one_deposit.client_name"></v-text-field>
              </v-col>
            </v-row>
            <v-row justify="space-between">
              <v-col cols="5">
                <v-text-field label="Pago em" :disabled="edit.infos" readonly :value="$moment(one_deposit.payed_at?.substring(0,10)).format('L')"></v-text-field>
              </v-col>
              <v-col cols="5">
                <v-text-field label="Depositado em" v-if="!edit.infos" :readonly="!edit.infos" :value="one_deposit.deposit_date_aux"></v-text-field>
                <v-menu
                  v-if="edit.infos"
                  :readonly="!edit.infos" 
                  ref="deposit_date"
                  v-model="deposit_date_picker_menu"
                  :close-on-content-click="false"
                  :return-value.sync="one_deposit.deposit_date"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field :rules="required" :value="$moment(one_deposit.deposit_date).format('L')" label="Depositado em" readonly v-bind="attrs" v-on="on" ></v-text-field>
                  </template>
                  <v-date-picker v-model="one_deposit.deposit_date" no-title scrollable >
                    <v-spacer></v-spacer>
                    <v-btn text @click="deposit_date_picker_menu = false" > fechar </v-btn>
                    <v-btn text color="primary" @click="$refs.deposit_date.save(one_deposit.deposit_date)" > OK </v-btn>
                  </v-date-picker>
                </v-menu>

              </v-col>
            </v-row>
            <v-row justify="space-between" v-if="one_deposit.status_id == status_id_map['Concluded'] || one_deposit.returned">
              <v-col cols="5">
                <v-text-field label="Concluído por" :disabled="edit.infos" readonly :value="one_deposit.concluded_by"></v-text-field>
              </v-col>
              <v-col cols="5">
                <v-text-field label="Concluído em" :disabled="edit.infos" readonly :value="$moment(one_deposit.concluded_at?.substring(0,10)).format('L')"></v-text-field>
              </v-col>
            </v-row>
            <v-row justify="space-between">
              <v-col cols="5">
                <v-text-field label="Banco" v-if="!edit.infos" :readonly="!edit.infos" :value="one_deposit.deposit_bank"></v-text-field>
                <v-select v-if="edit.infos"  :items="company_banks" v-model="one_deposit.deposit_bank" :rules="[...required]" label="Banco" ></v-select>
              </v-col>
              <v-col cols="5">
                <v-text-field label="Empresa"  v-if="!edit.infos" :readonly="!edit.infos" :value="one_deposit.deposit_company"></v-text-field>
                <SelectCompany v-if="edit.infos" without_icon @newCompany="handleNewCompany" :company="one_deposit.deposit_company"></SelectCompany>
              </v-col>
            </v-row>

            <v-col class="mb-3 pt-0" v-if="isDirector() || isAnalyst()">
              <f-btn v-if="!edit.infos" edit @click="editInfos"></f-btn>
              <f-btn v-if="edit.infos" cancel @click="cancelEditInfos"></f-btn>
              <f-btn v-if="edit.infos" save @click="submitInfos"></f-btn>
            </v-col>
            <!-- <v-row class="mb-2" justify="center" v-if="one_deposit.status_id == status_id_map['Payed'] || one_deposit.status_id == 17">
              <f-btn edit class="mb-5" @click="editDialog" v-if="can_edit"></f-btn>
            </v-row> -->
            <v-divider></v-divider>
            <v-row justify="center" class="mb-5">
              <v-expansion-panels accordion multiple>
                <v-expansion-panel>
                  <v-expansion-panel-header>Informações do Depósito</v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-col class="py-1">
                      <v-text-field label="Total" :disabled="edit.infos" readonly :value="one_deposit.value?.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})"></v-text-field>
                    </v-col>
                    <v-col class="py-1">
                      <v-text-field label="À vista" :disabled="edit.infos" readonly :value="one_deposit.entrance_value?.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})"></v-text-field>
                    </v-col>
                    <v-col class="py-1">
                      <v-text-field label="Bloqueado 1 dia" :disabled="edit.infos" readonly :value="one_deposit.one_day_value?.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})"></v-text-field>
                    </v-col>
                    <v-col class="py-1">
                      <v-text-field label="Bloqueado 2 dias" :disabled="edit.infos" readonly :value="one_deposit.two_days_value?.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})"></v-text-field>
                    </v-col>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel>
                  <v-expansion-panel-header>Anexos</v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <div>
                      <FileAttachment :readonly="!can_edit" :update_infos="{MODEL: 'Deposit', id: one_deposit.id}" :attached_file_url="one_deposit.attached_file_url" @newFileUrl="handleNewFileUrl"></FileAttachment>
                    </div>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel>
                  <v-expansion-panel-header>Comentário</v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <div>
                      <f-btn edit @click="editComment" v-if="had_permissions"></f-btn>
                      <v-textarea v-model="one_deposit.comment" :readonly="!edit.comment"></v-textarea>
                      <f-btn v-if="edit.comment" cancel @click="cancelEditComment"></f-btn>
                      <f-btn v-if="edit.comment" save @click="submitComment"></f-btn>
                    </div>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-row>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-row v-if="had_permissions">
            <v-col cols="6" class="d-flex justify-center" v-if="one_deposit.status_id == status_id_map['Payed'] || one_deposit.status_id == status_id_map['Confirmed']">
              <v-btn v-if="canManageDepositActions" color="error" width="100%" rounded @click="problemDeposit()" :disabled="loading_saving"><v-icon left>mdi-alert-circle</v-icon>Problema</v-btn>
            </v-col>
            <v-col cols="6" class="d-flex justify-center" v-if="one_deposit.status_id == status_id_map['Payed'] || one_deposit.status_id == status_id_map['Confirmed']">
              <v-btn v-if="canSeeEmContaButton" color="success" width="100%" rounded @click="concludeDeposit()" :disabled="loading_saving"><v-icon left>mdi-bank-check</v-icon>Em conta</v-btn>
            </v-col>
            <!-- para a pagina concluidos -->
            <v-col cols="12" align='center' v-if="one_deposit.status_id == status_id_map['Concluded'] && !one_deposit.returned">
              <v-alert type="success" :value="true">
                Depósito em conta
              </v-alert>
            </v-col>
            <v-col cols="12" align='center' v-if="one_deposit.returned">
              <v-alert type="error" :value="true">
                <div>
                  Depósito retornado! 
                </div>
                <div>
                  Motivo: {{one_deposit.returned_due}}
                </div>
                <div>
                  Valor: {{one_deposit.returned_value?.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})}}
                </div>
                <div>
                  Retornado em: {{$moment(one_deposit.updated_at?.substring(0,10)).format('L')}}
                </div>
              </v-alert>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <edit-deposit-dialog :edit_dialog="edit_dialog" :deposit="one_deposit" @closeEditDialog="handleCloseEditDialog" @doneUpdate="handleDoneUpdate"></edit-deposit-dialog>
    <problem-dialog v-if="problem_dialog" :problem_dialog="problem_dialog" :deposit="one_deposit" @doneReturned="handleDoneReturned" @closeDialog="handleCloseDialog" ></problem-dialog>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import Api from '@/api/index';
import status from "@/_backoffice/_financial/mixins/status.js"
import validations from '@/mixins/validations'


export default {
  name: 'DepositDialog',
  mixins: [ status, validations ],
  components: {
    AttachDoc: () => import('../../shipping/driver/AttachDoc'),
    EditDepositDialog: () => import('./EditDepositDialog'),
    ProblemDialog: () => import('./ProblemDialog'),
    FileAttachment: () => import('@/components/shared/FileAttachment.vue'),
    DialogOrdersPayedBySource: () => import("@/_backoffice/_financial/components/payment/shared/DialogOrdersPayedBySource.vue"),
    DownloadPaymentResume: () => import("@/_backoffice/_financial/components/payment/shared/DownloadPaymentResume.vue"),
    SelectCompany: () => import("@/_backoffice/_registrations/components/shared/SelectCompany.vue"),
  },
  props: {
    deposit: {
      type: Object
    },
    deposit_dialog: {
      type: Boolean
    }
  },
  data() {
    return {
      edit_dialog: false,
      one_deposit: {},

      new_attach: false,
      new_document: {},

      problem_dialog: false,
      loading_saving: false,
      comment_backup: "",
      edit: {
        comment: false,
        infos: false,
      },
      selected_deposit_id: null,
      deposit_date_picker_menu: false,
      company_banks: ['Itaú','Sicoob','Caixa','Banco do Brasil'],
    }
  },
  methods: {
    handleNewCompany(new_company){
      this.one_deposit.deposit_company = new_company
    },
    editComment(){
      this.edit.comment = true
      this.comment_backup = this.one_deposit.comment
    },
    editInfos(item){
      this.edit.infos = true
      this.selected_deposit_id = item.id
      
      let splitted = this.one_deposit.deposit_date_aux.split('/')
      let formatted_data = `${splitted[2]}-${splitted[1]}-${splitted[0]}`;
 
      this.one_deposit.deposit_date = this.$moment(formatted_data).add(12, 'hours').format('YYYY-MM-DD[T12:00:00.000Z]')
    },
    cancelEditComment(){
      this.edit.comment = false
      this.one_deposit.comment = this.comment_backup
    },
    cancelEditInfos(){
      this.edit.infos = false
    },
    submitComment(){
      const {id} = this.one_deposit
      let obj = { 
        id,
        comment: this.one_deposit.comment
      }
      this.updateDeposit(obj, true)
      this.edit.comment = false
    },
    submitInfos(){
      const {id, deposit_company, deposit_bank, deposit_date} = this.one_deposit
      let obj = { 
        id,
        deposit_company,
        deposit_bank,
        deposit_date: deposit_date
      }
      this.updateDeposit(obj, true)
      this.edit.infos = false
    },
    handleNewFileUrl(data){
      this.handleDoneUpdate(data)
    },
    handleCloseDialog(){
      this.problem_dialog = false
    },
    problemDeposit(){
      this.problem_dialog = true
    },
    handleDoneReturned(e){
      this.problem_dialog = false
      this.$emit('doneReturned')
    },
    concludeDeposit(){
      let c = confirm('Certeza em CONCLUIR o depósito?')

      if (c){
        const {id, } = this.one_deposit
        let obj = {
          id,
          status_id: this.status_id_map['Concluded'],
          
          concluded_at: new Date().toISOString()?.substring(0,10),
          concluded_by_id: this.current_user_employee_id,
        }
        this.updateDeposit(obj, true)
      }
    },
    updateDeposit(obj, with_emit = false){
      let noti = {
        type: 'success',
        msg: 'Feito com sucesso'
      }
      this.loading_saving = true
      Api.Deposit.update(obj).then(r => r.data).then(r => {
        this.one_deposit = {
          ...this.one_deposit,
          ...r,
        }
        if (with_emit){
          this.$emit('doneUpdate')
        }
      }).catch(error => {
        console.log(error)
        noti = {
          type: 'error',
          msg: `Erro: ${error}`
        }
      }).finally(()=>{
        this.loading_saving = false
        this.$emit('closeDepositDialog')
        this.addNotification(noti)
      })
    },
    setupOneDeposit(){
      if (this.deposit){
        this.one_deposit = {
          ...this.deposit
        }
      }
    },
    submitNewAttach(){
      const {id, } = this.one_deposit
      let obj = {
        id, 
        document: this.new_document
      }
      this.updateDeposit(obj)
    },
    handleDoneDoc(e) {
      this.new_attach = true
      this.new_document = {...e}
    },
    handleRemoveDoc(){
      this.$emit('removeDoc')
      this.new_attach = false
      this.new_document = {}
    },
    editDialog() {
      this.edit_dialog = true
    },
    handleCloseEditDialog() {
      this.edit_dialog = false
    },
    handleDoneUpdate(e) {
      this.one_deposit = {
        ...e
      }
      this.edit_dialog = false
      this.$emit('doneUpdate')
    },
    ...mapActions({
      
    }),
  },
  computed: {
    canManageDepositActions() {
      return this.isDirector() || this.isManager() || this.isAnalyst()
    },
    canSeeEmContaButton() {
      return this.isDirector() || this.isAnalyst()
    },
    had_permissions(){
      return !this.isCreditAnalyst();
    },
    can_edit(){
      if (!!this.deposit.confirmed_at){
      return this.isAnalyst() || this.isDirector() 
    }else{
      return this.isAnalyst() || this.isDirector() || this.isManager() 
    }
    },
    ...mapState({
      profile: state => state.User.oneUser,
    }),
  },
  mounted () {
    this.setupOneDeposit();
  },
  watch: {
    deposit_dialog(nv) {
      if (nv) {
        this.setupOneDeposit()
      }
    }
  },
}
</script>

<style lang="scss" scoped>

</style>
